import { SparklesIcon } from 'lucide-react';

import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { cn } from 'utils/shadcn';

interface AILocationHintBannerProps {
  isVisible: boolean;
  className?: string;
}

export function AILocationHintBanner({
  isVisible,
  className = '',
}: AILocationHintBannerProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={cn(
        'rounded border-l-4 border-accent-500 bg-accent-50 p-3 mb-1',
        className
      )}
    >
      <Flex align='center' gap='xs' justify='between'>
        <Flex align='center' gap='sm' className='flex-1'>
          <SparklesIcon
            className='h-4 w-4 stroke-accent-600! shrink-0'
            strokeWidth={2}
          />
          <Typography variant='body-xs' className='text-neutral-700'>
            We detected a new location that will be created upon load
            submission. You may still choose another location.
          </Typography>
        </Flex>
      </Flex>
    </div>
  );
}
